import { useContext } from 'react';
import { FlashMessageContext, FlashMessageContextProps } from './flash-messages.context';

const useFlashMessage = (): FlashMessageContextProps => useContext(FlashMessageContext);

export default useFlashMessage;
